import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { appSettings } from 'wanderu-config';
import Logger from 'wanderu-logger';

const logger = Logger.getLogger('GoogleLogin');

function GoogleLogin({ onClick }) {
    useEffect(() => {
        const initGoogleLogin = () => {
            try {
                if (window?.google?.accounts?.id) {
                    window?.google?.accounts?.id?.initialize({
                        auto_select: true,
                        callback: onClick,
                        client_id: appSettings.config.google.clientId,
                        use_fedcm_for_prompt: true,
                    });

                    window?.google?.accounts?.id?.renderButton(
                        document.getElementById('googleButton'),
                        {
                            width: '280',
                        },
                    );

                    logger.event('initialize', 'succeeded');
                } else {
                    logger.event('initialize', 'failed', 'window.google.accounts.id does not exist');
                }
            } catch (ex) {
                logger.error('initialize', 'failed', { ex });
            }
        };

        if (window?.google?.accounts?.id) { // the SDK has already loaded, so we can init now
            initGoogleLogin();
        } else { // the SDK has not loaded, so we need to wait for it to load
            window.onGoogleLibraryLoad = initGoogleLogin;
        }
    }, []);

    return (
        <>
            <script src="https://accounts.google.com/gsi/client" async></script>
            <div id="googleButton"></div>
        </>
    );
}

GoogleLogin.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default GoogleLogin;
